export const getCommentPermissions = (comment, currentUserId, eventOwnerId) => {
  const canDelete = currentUserId && (
    comment.user?._id === currentUserId ||
    comment.user === currentUserId ||
    eventOwnerId === currentUserId
  )

  const canEdit = currentUserId && (
    comment.user?._id === currentUserId ||
    comment.user === currentUserId
  )

  return {
    canDelete,
    canEdit
  }
}